import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {AgentResponse} from "@/services/models/agentsResponse";
import {Agent} from "@/services/models/agentsResponse";

export const agentsApiSlice = createApi({
    reducerPath: 'agentsApi',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['Agents'],
    endpoints: (builder) => ({
        getAgents: builder.query<Agent[], void>({
            query: () => ({
                url: `Agents`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
            providesTags: (result) =>
                result
                    ? [{type: 'Agents', id: 'LIST'}]
                    : [{type: 'Agents', id: 'LIST'}],
        }),
        getAgent: builder.query<AgentResponse, { agentId: string, version: string }>({
            query: ({agentId, version}) => ({
                url: `Agent/${agentId}\@${version}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
        deleteAgent: builder.mutation<AgentResponse,  { agentId: string}>({
            query: ({agentId}) => ({
                url: `Agent/${agentId}`,
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
        getAgentSuggestions: builder.query<{ agentId: string; suggestions: string[] }, { agentId: string; limit?: number }>({
            query: ({ agentId, limit = 2 }) => ({
                url: `Agent/${agentId}/suggestions?limit=${limit}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
    }),
})

const {
    useGetAgentsQuery,
    useGetAgentQuery,
    useDeleteAgentMutation,
    useGetAgentSuggestionsQuery
} = agentsApiSlice
export const agentsApiActions = {
    useGetAgentsQuery,
    useGetAgentQuery,
    useDeleteAgentMutation,
    useGetAgentSuggestionsQuery
}